<script>
import { required } from "vuelidate/lib/validators";
import { equalTo } from "../../../helpers/validator_extend_function";

export default {
  components: {},
  props: {},
  data() {
    return {
      invalidCheck: "",
    };
  },
  validations: {
    invalidCheck: { required, equalTo: equalTo(true) },

    form: ["invalidCheck"],
  },
  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">تعليمات وشروط التقديم</h5></div>

      <div class="col-md-12">
        <ol>
          <li>
            <p>حجز اسم منظمة او فريق عمل تطوعي عن طريق الاستمارة الالكترونية. </p>
          </li>
          <li>
            <p>سيتم تدقيق الاسم و المعلومات من قبل موظف التسجيل في المركز , وفي حال الموافقة على الاسم سيتم الاتصال بكم بأقرب وقت ممكن لإكمال إجراءات التسجيل الأخرى.</p>
          </li>
        </ol>
          <hr class="hr-title" />
          <div class="break-title"><h5 class="mb-4">استمارة حجز اسم منظمة او فريق عمل تطوعي </h5></div>
           <ul class="" style="margin-right: 16px">
            <li class="mb-1">
              <h5 class="font-size-14">هذه الاستمارة لغرض حجز اسم منظمة او فريق عمل تطوعي في مركز العمل التطوعي لهيئة الحشد الشعبي كجزء من اجراءات التسجيل</h5>
            </li>
          </ul>


        <div class="form-check check-promise mb-3">
          <label class="form-check-label" for="invalidCheck">
            اتعهد بصحة كافة البيانات التي سيتم ادخالها وبخلافه تهمل الاستمارة .
          </label>
          <input
            class="form-check-input"
            type="checkbox"
            value=""
            id="invalidCheck"
            v-model="invalidCheck"
            :class="{ 'is-invalid': $v.invalidCheck.$error }"
          />
          <div v-if="$v.invalidCheck.$error" class="invalid-feedback">
            <span v-if="!$v.invalidCheck.required || !$v.invalidCheck.equalTo"
              >للتقديم على الاستمارة يجب الموافقة على التعهد</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
